module.exports = __webpack_public_path__ + "static/media/Salad-Paul-Marc-Mitchell-Growing-Underground.7d4de92e.jpg";